import { toasterUtil } from './toaster-util'

export type BackendHTTPError = {
  message: string
  code: number
}

// Backend error codes (`error.client.*` / `error.server.*`) are not meant for users. Map the
// known ones to human-readable copy; anything unmapped falls back to a generic message rather
// than leaking a raw code into a toast.
const FRIENDLY_MESSAGES: Record<string, string> = {
  'error.client.promo_code_invalid': "That promo code can't be applied to this plan.",
  'error.client.promo_code_required': 'Please enter a promo code.',
}

const toFriendlyMessage = (message: string): string => {
  if (FRIENDLY_MESSAGES[message]) return FRIENDLY_MESSAGES[message]
  // Only surface raw text that isn't an internal error code.
  if (/^error\.(client|server)\./.test(message)) return 'Something went wrong. Please try again.'
  return message
}

export const errorUtil = {
  parseHttpError: (error: any): BackendHTTPError => {
    return {
      message: error.message ?? error.toString(),
      code: error.code ?? 500,
    }
  },
  handleHttpError: (error: any): void => {
    const err = errorUtil.parseHttpError(error)
    if (err.code === 403) {
      window.location.replace('/')
      return
    }
    const message = toFriendlyMessage(err.message)
    if (err.code >= 500) {
      toasterUtil.error(message)
    } else {
      toasterUtil.warn(message)
    }
  },
}
